import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { getUserNip } from '../../../../utils/adminTools/getUserNip';
import { LoadingButton } from '@mui/lab';
import { getBalanceTypeUser } from '../../../../utils/formatWallet';
import useWallet from '../../../../hooks/useWallet';
import { firestore } from '../../../../contexts/FirebaseContext';
import useWalletEvents from '../../../../hooks/useWalletEvents';
import useAuthUsers from '../../../../hooks/useAuthUsers';

function DialogConfirmCancEnvAssignedUs({ data, dataAdmin, dialogProp }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <Box>
      <Button
        variant={dialogProp ? dialogProp?.variant || 'contained' : 'contained'}
        size={dialogProp ? dialogProp?.size : 'medium'}
        color={dialogProp ? dialogProp?.color : 'error'}
        onClick={() => setOpenDialog(true)}
      >
        Confirmar cancelacion
      </Button>
      <DialogConfirmCancerlar open={openDialog} onClose={setOpenDialog} dataEnvio={data} adminId={dataAdmin?.id} />
    </Box>
  );
}

export default DialogConfirmCancEnvAssignedUs;

function DialogConfirmCancerlar({ open, onClose, dataEnvio, adminId }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();
  const { recargar } = useWallet();
  const { handleWalletEvent } = useWalletEvents();
  const { currentUser, verifyUserNip } = useAuthUsers();

  const handleClose = () => {
    reset();
    onClose(false);
  };

  const cancelEnvio = async (dataForm) => {
    // setLoading(true);

    if (verifyUserNip(dataForm.nip)) {
      await firestore.collection('cotizaciones').doc(dataEnvio?.id).update({ state: 'CANCELADO', status: 'CANCELADO' });

      const obj = {
        nameEvent: 'ADD',
        ownerUserID: dataEnvio.hostUser_id,
        category_service_id: 'PAQUETERIA',
        amount: dataEnvio.shippingValue,
        message: dataForm.message || 'Sin mensaje',
        reason: 'Envio cancelado',
        payment_method: 'ABONO',
        payment_source: 'DAGPACKET',

        rerport_id: '',
        // reporteAction: false,
        // para que la funcion de registrar reporte se ejecute

        // array de funciones que se ejecutan si toda va bien
        successFuncts: [handleClose],
        successFunctsParams: [setLoading(false)],
        // si deseamos que el snackbar se muestre
        successSnackbar: true
      };

      await handleWalletEvent(obj);

      // setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar('Ingrese un NIP correcto', { variant: 'error' });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirmar cancelacion del envio</DialogTitle>
      <DialogContent>
        <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(cancelEnvio)}>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
            {errors.message && (
              <Typography color="error" fontSize="13px">
                Ingrese un mensaje
              </Typography>
            )}
          </Box>
          <LoadingButton loading={loading} fullWidth variant="contained" type="submit">
            Cancelar envio
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
